import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewInit, NgZone, ChangeDetectionStrategy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { WarningdialogComponent } from "../../modalDialogs/warningDialog/warningDialog.component";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { CoreCOMService } from "../../services/com.service";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLogService } from "../../services/log.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { WebShopService } from "../../services/webShop.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { WebShopMode } from "../../shared/contentTypes";
import Utils from "../../shared/utils";
import { InHouseOrderService } from "../../services/inHouseOrder.service";

@Component({
  selector: "ya-qrcodescanner",
  templateUrl: "./qrcodescanner.component.html",
  styleUrls: ["./qrcodescanner.component.scss"],
  providers: [OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QrcodeScannerComponent implements OnInit, OnDestroy, AfterViewInit {
  public flashEnabled: boolean = false;
  public isMobile: boolean = false;
  public hasAccess: boolean = true;
  public navigateBackHandler: () => void;
  public tablecode: string = null;
  public isGroupOrder: boolean = false;
  public get groupOrderNoCameraHTML(): string {
    return this._coreLanguageService.value("phGroupOrder_QRCode_Scanner_NoCam_Info");
  }

  private scannerTimeOut: NodeJS.Timer
  public get noCameraHTML(): string {
    return this._coreLanguageService.value("phQRCodeScanner_NoCamera_HTML");
  }
  public isSmallView: boolean = false;

  // browser scanner
  public zXingScanner; // todo mace a boolean for showing its shows or destroy the scanner
  public hasDevices: boolean;
  public hasPermission: boolean;

  constructor(private _coreLogService: CoreLogService
    , private _coreCOMService: CoreCOMService
    , private _router: Router
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _routerHelperService: RouterHelperService
    , private _webShopService: WebShopService
    , private _inHouseOrderService: InHouseOrderService
    , private _coreLanguageService: CoreLanguageService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _activatedRoute: ActivatedRoute
    , _mainnavService: MainnavService) {
    this.isSmallView = _mainnavService.viewType === ViewType.Small;

  }

  ngAfterViewInit(): void {
    // const me = this;
    // setTimeout(() => {
    //   me.startScan();
    // }, 500);
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("MenuGroupComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.isMobile = me._coreCOMService.environment.client.isMobile;

    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData && routeTargetData["isGroupOrder"]) {
      me.isGroupOrder = true;
      me.tablecode = routeTargetData["tablecode"];
    }

    if (me.isMobile) {
      me.scanMobileQRCode();
    } else {
      me._overlaySpinnerService.ShowLayoutSpinner();
      me.zXingScanner = true;
    }
  }

  ngOnDestroy() {
    const me = this;
    clearTimeout(me.scannerTimeOut);
    if (me.isMobile) {
      me._coreCOMService.environment.QRCodeScanner.destroy();
    } else {
      me.zXingScanner = false;
    }
  }

  //#region zxing-scanner

  /**zxing-scanner event when camera found
   * @devices find back camera in first try. if no back camera found return the last camera from the list of cameras
   */
  onCamerasFound(devices: MediaDeviceInfo[]): void {
    const me = this;
    me.hasDevices = Boolean(devices && devices.length > 0);
    if (!me.hasDevices) {
      me.onBrowserCameraErrorHandler();
    } else {
      setTimeout(() => {
        me._overlaySpinnerService.HideLayoutSpinner();
      }, 1000);
    }
  }

  /**define browser access
   * @has by zXing/qrcode scanner plugin after initialization
   */
  public onPermissionResponse(has: boolean): void {
    const me = this;
    me.hasAccess = has;
    if (!has) {
      me._overlaySpinnerService.HideLayoutSpinner();
      //todo me.openInhauseLocationWarningDialog("phQRCode_ScanFail_Title", "phQRCode_ScanFail_Content", "phQRCode_ScanFail_Button_Text");
    }
  }

  /**zxing-scanner handle error on camera device */
  private onBrowserCameraErrorHandler() {
    const me = this;
    me.hasAccess = false;
    //todo me.openInhauseLocationWarningDialog("phQRCode_ScanFail_Title", "phQRCode_ScanFail_Content", "phQRCode_ScanFail_Button_Text");
  }

  /**zxing-scanner handle error when no camerafound */
  public onCamerasnotfound() {
    const me = this;
    me.onBrowserCameraErrorHandler();
    me._coreLogService.error("QrcodeScannerComponent", "onCamerasnotfound");
  }

  /**zxing-scanner handle error for scanning */
  public scanErrorHandler($event) {
    const me = this;
    me.onBrowserCameraErrorHandler();
    me._coreLogService.error("QrcodeScannerComponent", "scanErrorHandler", $event);
  }

  /**zxing-scanner handle error fail in scanning */
  public scanFailureHandler($event) {
    const me = this;
    me.onBrowserCameraErrorHandler();
    me._coreLogService.error("QrcodeScannerComponent", "scanFailureHandler", $event);
  }

  /**zxing-scanner return qrcode scanned by camera
   * @result a string that scanned by qrcode-scanner
   */
  public scanCompleteHandler(result) {
    const me = this;
    me.zXingScanner = false;

    me.scanDone(result.text);
  }

  /** achtung QRCodeInputComponent auch beachten */
  public scanDone(scan: string): void {
    const me = this;

    const params = scan.substr(scan.indexOf("?"));
    const urlParams = new URLSearchParams(params);
    const type = urlParams.get("type");
    const isGroupCode = scan.includes("/group/");

    if (me.isGroupOrder) {
      if (isGroupCode && !scan.endsWith("/group/")) {
        const groupcode = scan.substring(scan.lastIndexOf("/") + 1);
        me._routerHelperService.setRouteTargetDataByKey("groupcode", groupcode); // todo eventuell als teil der url übergeben (siehe router 'groupOrderInvite/:groupcode') damit es refresht werden kann
        me._router.navigate(["/groupOrderInvite"], { replaceUrl: true });
      } else if (type === "QRcodescanner") {
        me.PushChanges();
        me.openWarningDialog("phGroupOrder_WrongCode_Title", "phGroupOrder_WrongCode_Description", "phGroupOrder_WrongCode_Button");
      } else {
        me.PushChanges();
        me.openWarningDialog("phQRCode_ScanFail_Title", "phQRCode_ScanFail_Content", "phQRCode_ScanFail_Button_Text");
      }
    } else {
      // tableCode
      if (type === "QRcodescanner") {
        const qrcode = urlParams.get("QRcode");
        const next_location = 0; // 0 > zum erzwingen der Warnung (da der QrCode sich unterscheidet, somit der Tisch)
        me._webShopService.openWarningResetBasketDialogIfNeed(next_location, WebShopMode.OrderToTable, async (agree) => {
          if (agree) {
            me._overlaySpinnerService.ShowLayoutSpinner();
            //! todo sollte hier nicht die nickname eingabe geöffnet werden? CDS muss beachtet werden
            try {
              await me._inHouseOrderService.tryOpenTableCode(qrcode);
            } catch (error) {
              me._coreLogService.error("QrcodeScannerComponent.submitQRCodeData", "_inHouseOrderService.tryOpenTableCode(catch)", qrcode, error);
            }
            me._overlaySpinnerService.HideLayoutSpinner();
          } /* else do nothing */
        });
      } else if (isGroupCode) {
        me.PushChanges();
        me.openWarningDialog("phInHouse_WrongCode_Title", "phInHouse_WrongCode_Description", "phInHouse_WrongCode_Button");
      } else {
        me.PushChanges();
        me.openWarningDialog("phQRCode_ScanFail_Title", "phQRCode_ScanFail_Content", "phQRCode_ScanFail_Button_Text");
      }
    }
  }

  //#endregion zxing-scanner

  public turnOnFlashLight() {
    const me = this;
    me._coreCOMService.environment.QRCodeScanner.enableLight();
    me.flashEnabled = true;
    me.PushChanges();
  }

  public turnOffFlashLight() {
    const me = this;
    me._coreCOMService.environment.QRCodeScanner.disableLight();
    me.flashEnabled = false;
    me.PushChanges();
  }

  private scanMobileQRCode() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._coreCOMService.environment.QRCodeScanner.prepare()
      .then(status => {
        me._coreCOMService.environment.QRCodeScanner.show()
          .then(status => {
            me._overlaySpinnerService.HideLayoutSpinner();
            me.scannerTimeOut = setTimeout(() => {
              me._coreCOMService.environment.QRCodeScanner.destroy()
                .then((status) => {
                  me.PushChanges();
                  me.openWarningDialog("phQRCode_ScanFail_Title", "phQRCode_ScanFail_Content", "phQRCode_ScanFail_Button_Text");
                })
            }, 30000);
            me._coreCOMService.environment.QRCodeScanner.scan()
              .then(contents => {
                clearTimeout(me.scannerTimeOut);
                me._coreCOMService.environment.QRCodeScanner.destroy();
                me.scanDone(contents);
              })
              .catch(error => {
                me._coreCOMService.environment.QRCodeScanner.destroy();
                me.hasAccess = false;
                me.PushChanges();
                me._coreLogService.error("QrcodeScannerComponent.scan()", " QRCodeScanner.scan()", error);
              });
          })
          .catch(error => {
            me._overlaySpinnerService.HideLayoutSpinner();
            me._coreCOMService.environment.QRCodeScanner.destroy();
            me.hasAccess = false;
            me.PushChanges();
            me._coreLogService.error("QrcodeScannerComponent.scan()", " QRCodeScanner.show()", error);
          })
      })
      .catch(error => {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._coreCOMService.environment.QRCodeScanner.destroy();
        me.hasAccess = false;
        me.PushChanges();
        me._coreLogService.error("QrcodeScannerComponent.scan()", " QRCodeScanner.prepare()", error);
      });
  }

  public routeToManualQRCode() {
    const me = this;
    me._router.navigate(["/qrcodeinput"])
  }

  private openWarningDialog(title: string, content: string, buttonLabel: string) {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: title
        , content: content
        , btnLabel: buttonLabel
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe(() => {
      // try to reset scanner
      if (me.isMobile) {
        me.scanMobileQRCode();
      } else {
        me.zXingScanner = true;
      }
      me.PushChanges();
    });
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.handleNavigateBack();
    }
  }

  public handleNavigateBack(force: boolean = true) {
    const me = this;
    if (me.isMobile) {
      me._overlaySpinnerService.HideLayoutSpinner();
      clearTimeout(me.scannerTimeOut);
      me._coreCOMService.environment.QRCodeScanner.destroy()
        .then((status) => {
          if (force) {
            setTimeout(() => {
              me.navigateBack();
            }, 600);
          }
        })
        .catch((error) => {
          me._coreLogService.error("QrcodeScannerComponent.handleNavigateBack()", " QRCodeScanner.destroy()", error);
          me.navigateBack();
        });
    } else {
      me.zXingScanner = false;
      me.navigateBack();
    }
  }

  private navigateBack(): void {
    const me = this;
    if (me.isGroupOrder && me.tablecode) {
      me._routerHelperService.setRouteTargetDataByKey("tablecode", me.tablecode);
      me._router.navigate(["/groupOrderCreateGroup"]);
    } else {
      me._routerHelperService.navigateBackSimple();
    }
  }
}
